module.exports = __webpack_public_path__ + "img/loader.a38b0efa.svg";